export const MANDATORY_DATA_REQUEST = 'MANDATORY_DATA_REQUEST';
export const MANDATORY_DATA_SUCCESS = 'MANDATORY_DATA_SUCCESS';
export const MANDATORY_DATA_FAIL = 'MANDATORY_DATA_FAIL';

